import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { ValList } from '@/common/val/ValList';

export const IndirSaleLineDetail = () => {
  const { entityObj } = useEntityMgr();

  // Links the Direct Sale tab to the Direct Sale's own detail page
  const augIndirSaleFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.code.component = <EntitySelect key="code" fieldDef={fieldToFieldDef.code} />;
  };

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'indirSaleTab',
      label: 'Indirect Sale',
      content: <EntityForm entity="INDIR_SALE" entityId={entityObj.indirSaleId} augFieldDefs={augIndirSaleFieldDefs} />,
    },
    {
      id: 'valTab',
      label: 'Validations',
      content: <ValList parentEntity="INDIR_SALE_LINE" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
